import { User } from 'src/store/models/index.js'
import { Bookable, Subject, Lesson, Grade, Teacher } from 'src/store/models/timetable/index.js'

const entities = {
  users: User,
  bookables: Bookable,
  subjects: Subject,
  lessons: Lesson,
  grades: Grade,
  teachers: Teacher
}

export default {
  methods: {
    openTimetableFromEnitiy (entity) {
      if (!entity) return
      const name = Object.keys(entities).find(key => entity instanceof entities[key]) || 'users'
      const currentName = this.$route.name

      console.log('entity which comes in open', name, entity.id, entity)

      this.$router.push({
        name: currentName === 'management-timetable' ? 'management-timetable' : 'timetable',
        params: {
          entity: name,
          id: entity.id
        },
        query: { ...this.$route.query }
      })
    }
  }
}
